import { render, staticRenderFns } from "./SimpleCheckbox.vue?vue&type=template&id=99e271fc&"
import script from "./SimpleCheckbox.vue?vue&type=script&lang=js&"
export * from "./SimpleCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports